export const installControllerHook = (application) => {
    window.__sbControllers__ = () =>
        [...application.router.modulesByIdentifier.entries()].map(([identifier, mod]) => ({
            identifier,
            contextCount: mod.contexts?.length ?? 0,
        }));
};
